import React, {useCallback} from 'react';
import styled from 'styled-components';
import {VideoInfo} from 'shared/components/VideoPlayer/entity/VideoInfo';
import {Video} from 'shared/components/VideoPlayer/Video';

interface VideosProps {
    videos: VideoInfo[];
    watched: Record<string, boolean>;
    playVideo: (video: VideoInfo) => void;
}

export const Videos = ({videos, watched, playVideo}: VideosProps) => {
    const handleSelectVideo = useCallback(
        (video: VideoInfo) => () => playVideo(video),
        [playVideo]
    );

    return (
        <section aria-labelledby="getting-started-videos">
            <SectionHeader>
                <SectionTitle id="getting-started-videos">
                    Getting started videos
                </SectionTitle>
            </SectionHeader>
            <Grid>
                {videos.map((video, index) => (
                    <Video
                        key={video.id}
                        index={index}
                        videoInfo={video}
                        watched={!!watched[video.watchedKey]}
                        onClick={handleSelectVideo(video)}
                    />
                ))}
            </Grid>
        </section>
    );
};

const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 12px;
    margin-bottom: 12px;
`;

const SectionTitle = styled.div`
    margin: 0;
    font-size: 0.75em;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #60788e;
`;

const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 12px;

    @media (max-width: 991px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
`;
